<template>
  <v-card>
    <div class="pa-4">
      <div class="d-flex">
        <h4>Audio References</h4>
        <v-btn
          class="ml-auto"
          color="primary"
          rounded
          small
          v-if="allowAdd != false"
          :disabled="audio.length == 3"
          @click="
            () => {
              this.$refs.ref_video && this.$refs.ref_video.reset();
              this.media = [
                {
                  title: '',
                  isURL: true,
                  url: '',
                  file: '',
                },
              ];
              dialog = true;
            }
          "
          ><i class="fa fa-plus"></i
        ></v-btn>
      </div>
    </div>
    <v-divider></v-divider>
    <div class="pa-4">
      <div
        v-if="musicAudioLoading"
        class="d-flex align-items-center justify-center"
      >
        <v-progress-circular indeterminate />
      </div>
      <v-row v-else>
        <v-col v-for="(video, i) of audio" :key="video.id" sm="6" cols="12">
          <div style="position: relative">
            <audio controls style="width:100%">
              <source :src="video.url"/>
            </audio>
            <div
              style="
                position: absolute;
                width: 20px;
                height: 20px;
                bottom: 0px;
                right: 0px;
                border-radius: 50%;
                border: 2px solid black;
                cursor: pointer;
              "
              v-if="allowAdd != false"
              @click="
                () =>
                  deleteMusicAudio({ id: authUser.id, idx: i, url: video.url })
              "
              class="red white--text d-flex align-center justify-center"
            >
              <i class="fa fa-trash"></i>
            </div>
          </div>
        </v-col>

        <div class="pa-4" v-if="audio.length == 0">
          <p class="ma-0">No Audio References Yet</p>
        </div>
      </v-row>
    </div>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="text-h6 grey lighten-2">
          Add Music Audios
        </v-card-title>
        <v-form ref="ref_video" @submit="lc_addMedia">
          <div class="pa-4">
            <!-- <div class="d-flex">
            <v-select
              dense
              :items="['Audio', 'Audio']"
              v-model="mediaType"
              flat
              hide-details
              outlined
              label="Media Type"
            ></v-select> -->
            <v-btn
              class="ml-3"
              color="primary"
              :disabled="audio.length == 3"
              @click="addMedia"
              >Add</v-btn
            >
            <!-- </div> -->
            <div class="" v-for="(type, i) of media" :key="i">
              <!-- <div class="audio" v-if="type == 'Audio'">
              <v-text-field
                outlined
                flat
                dense
                hide-details
                label="Audio Title"
              ></v-text-field>
              <v-text-field
                outlined
                flat
                dense
                hide-details
                class="mt-3"
                label="Audio URL"
              ></v-text-field>
              <div
                style="
                  position: absolute;
                  width: 20px;
                  height: 20px;
                  top: 50%;
                  font-size: 12px;
                  right: -10px;
                  border-radius: 50%;
                  border: 2px solid black;
                  cursor: pointer;
                "
                class="red white--text d-flex align-center justify-center"
                @click="e=>removeMedia(i)"
              >
                <i class="fa fa-trash"></i>
              </div>
            </div> -->
              <div class="video">
                <v-text-field
                  outlined
                  flat
                  dense
                  v-model="media[i].title"
                  label="Audio Title"
                  :rules="[myrules.required]"
                ></v-text-field>
                <v-checkbox v-model="media[i].isURL" label="Is URL" />
                <v-text-field
                  v-if="media[i].isURL"
                  outlined
                  flat
                  dense
                  class="mt-3"
                  label="Audio URL"
                  v-model="media[i].url"
                  :rules="[myrules.required]"
                ></v-text-field>
                <v-file-input
                  v-else
                  class="mt-3"
                  label="File input"
                  outlined
                  dense
                  v-model="media[i].file"
                  :rules="[myrules.required]"
                ></v-file-input>
                <div
                  v-if="media.length > 1"
                  style="
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    top: 50%;
                    font-size: 12px;
                    right: -10px;
                    border-radius: 50%;
                    border: 2px solid black;
                    cursor: pointer;
                  "
                  @click="(e) => removeMedia(i)"
                  class="red white--text d-flex align-center justify-center"
                >
                  <i class="fa fa-trash"></i>
                </div>
              </div>
            </div>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text type="submit"> Save </v-btn>
            <v-btn color="primary" text @click="dialog = false"> Cancel </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  name: "CreatorType",
  props: ["audio", "allowAdd"],
  data() {
    return {
      dialog: false,
      mediaType: "",
      media: [
        {
          title: "",
          isURL: true,
          url: "",
          file: "",
        },
      ],
    };
  },
  mounted() {
    let id = this.authUser.id;
    this.getMusicAudios(id);
  },
  methods: {
    async lc_addMedia(e) {
      e.preventDefault();
      let validate = this.$refs.ref_video.validate();
      if (validate) {
        let id = this.authUser.id;
        this.dialog = false;
        await this.addMusicAudio({ id, media: this.media });
      }
    },
    addMedia() {
      // let audio = this.media.filter((media) => media == "Audio");
      // let video = this.media.filter((media) => media == "Audio");
      //
      // if (this.mediaType == "Audio" && audio.length < 3) {
      //   this.media.push("Audio");
      // }
      if (this.media.length < 3 && this.audio.length < 3) {
        this.media.push({
          title: "",
          isURL: true,
          url: "",
          file: "",
        });
      }
    },
    removeMedia(idx) {
      if (this.media.length > 1)
        this.media = this.media.filter((_, index) => index != idx);
    },
  },
};
</script>

<style scoped>
.audio,
.video {
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  padding: 20px;
  margin: 15px 0;
  border-radius: 10px;
  position: relative;
}
</style>
